import { fetchJSON as fetchAPI } from './client';

export type ProgramDashboard = {
  program_id: string; objectives: number; workstreams: number; deliverables: number;
  quality_gates: number; backend_apis: number; performance_targets: number; generated_at: string;
};

export type ProgramValidation = {
  valid: boolean; zero_critical_bugs: boolean; zero_data_corruption: boolean;
  zero_tenant_leakage: boolean; zero_security_critical_findings: boolean;
  performance_budgets_achieved: boolean; scalability_targets_achieved: boolean;
  accessibility_passes: boolean; ci_cd_stable: boolean; observability_operational: boolean;
  backup_verified: boolean; recovery_verified: boolean; gaps?: string[];
};

export type PRT001Status = {
  program_id: string; objectives: number; workstreams: number; deliverables: number;
  production_readiness: boolean; pilot_ready: boolean; release_candidate: string; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const productionReadinessPRT001Api = {
  dashboard: () => fetchG<ProgramDashboard>('/prt001/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/prt001/objectives').then((r) => r.objectives),
  workstreams: () => fetchG<{ workstreams: { key: string; name: string; category: string; progress_pct: number; status: string }[] }>('/prt001/workstreams').then((r) => r.workstreams),
  deliverables: () => fetchG<{ deliverables: { key: string; name: string; type: string; status: string }[] }>('/prt001/deliverables').then((r) => r.deliverables),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/prt001/quality-gates').then((r) => r.gates),
  performance: () => fetchG<{ targets: { key: string; surface: string; target: string; unit: string }[] }>('/prt001/performance').then((r) => r.targets),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<ProgramValidation>('/prt001/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<PRT001Status>('/prt001/status'),
};
